import {Component, computed, forwardRef, Input, input} from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIcon} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {AccordionLinkGroup} from 'shared/pretty-easy-navigation/models';
import {PrettyEasyLinkGroupComponent} from '../pretty-easy-link-group/pretty-easy-link-group.component';
import {PrettyEasyLinkComponent} from '../pretty-easy-link/pretty-easy-link.component';

@Component({
    selector: 'app-pretty-easy-accordion-link-group',
    imports: [
        PrettyEasyLinkComponent,
        forwardRef(() => PrettyEasyLinkGroupComponent),
        TranslateModule,
        MatIcon,
        MatExpansionModule,
        MatTooltipModule
    ],
    templateUrl: './pretty-easy-accordion-link-group.component.html'
})
export class PrettyEasyAccordionLinkGroupComponent {
    @Input() isSidebarFolded: boolean;
    @Input() unfoldSidebar: () => void;
    public slot = input<AccordionLinkGroup>();
    public links = computed(() => this.slot().links);
    public label = computed(() => this.slot().label);
    public icon = computed(() => this.slot().icon || '');
    public classes = computed(() => {
        const classes = [
            'pretty-easy-accordion-link-group',
            ...this.slot().classes || []
        ];

        return classes;
    })
}
